// extracted by mini-css-extract-plugin
export var container = "index-module--container--ylZ3a";
export var formBox = "index-module--formBox--OR5gS";
export var fullWidth = "index-module--fullWidth--0aWfA";
export var header = "index-module--header--t1rdy";
export var inputLabel = "index-module--inputLabel--9H9K5";
export var messageContainer = "index-module--messageContainer--KV+ul";
export var messagePlaceholder = "index-module--messagePlaceholder--BB54q";
export var phoneContainer = "index-module--phoneContainer--ibsXK";
export var recaptcha = "index-module--recaptcha--m8d2U";
export var submit = "index-module--submit--hTXYD";
export var submitBox = "index-module--submitBox--tDUXK";
export var subtitle = "index-module--subtitle--sFtVv";
export var title = "index-module--title--5ubn8";
export var ttsFormBytext = "index-module--ttsFormBytext--4rhx7";